<h2 mat-dialog-title>Run Report</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="form-grid">

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="readonly-field">
      <mat-label>Report</mat-label>
      <input matInput [value]="template.title" readonly />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="readonly-field">
      <mat-label>Date</mat-label>
      <input matInput [value]="today | date: 'M/d/yyyy'" readonly />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Providers</mat-label>
      <mat-select formControlName="providerIds" multiple panelClass="searchable-panel"
        (selectionChange)="onProviderSelectionChange($event.value)">
        <mat-select-trigger>{{ triggerLabel }}</mat-select-trigger>
        <mat-option>
          <ngx-mat-select-search [formControl]="providerSearchControl" placeholderLabel="Search providers..." noEntriesFoundLabel="No providers found"></ngx-mat-select-search>
        </mat-option>
        @if (allProviders.length > 1) {
          <mat-option value="SELECT_ALL">Select all providers ({{ allProviders.length - 1 }})</mat-option>
        }
        @for (option of filteredProviderOptions; track option.id) {
          <mat-option [value]="option.id">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="full-width email-section">

      @if (showNotifyEachProvider) {
        <button mat-stroked-button type="button" class="notify-toggle-btn"
          [color]="notifyEachProvider ? 'primary' : undefined"
          (click)="notifyEachProvider = !notifyEachProvider">
          <mat-icon>{{ notifyEachProvider ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          Include each provider's email for their respective report
        </button>
      }

      @if (notifyEachProvider) {
        <div class="email-section-header">Additional recipients — added to every report</div>
      }

      @if (!allowProviderEmailRecipients) {
        <div class="non-prod-notice">Provider email selection is disabled in non-production environments.</div>
      }
      <div class="email-field-row">
        <mat-form-field appearance="outline" class="email-select-field">
          <mat-label>Email Recipients</mat-label>
          <mat-select formControlName="emailRecipients" multiple panelClass="searchable-panel"
            (selectionChange)="onEmailSelectionChange($event.value)">
            <mat-option>
              <ngx-mat-select-search [formControl]="emailSearchControl" placeholderLabel="Search by name or email..." noEntriesFoundLabel="No matches"></ngx-mat-select-search>
            </mat-option>
            @if (allowProviderEmailRecipients) {
              <mat-option value="ALL">ALL — All providers</mat-option>
            }
            @if (userEmail) {
              <mat-option [value]="userEmail">Me — {{ userEmail }}</mat-option>
            }
            @if (allowProviderEmailRecipients) {
              @for (option of filteredEmailOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }} — {{ option.value }}</mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
        @if (hasAnyEmails) {
          <button mat-stroked-button type="button" class="clear-btn" (click)="clearAllEmails()">Clear</button>
        }
      </div>

      <div class="add-email-row">
        <mat-form-field appearance="outline" class="add-email-field">
          <mat-label>Add unlisted email</mat-label>
          <input matInput type="email" [formControl]="customEmailControl" (keydown.enter)="addCustomEmail()" />
          @if (customEmailControl.hasError('email') && customEmailControl.touched) {
            <mat-error>Enter a valid email address</mat-error>
          }
        </mat-form-field>
        <button mat-stroked-button type="button" (click)="addCustomEmail()"
          [disabled]="!customEmailControl.value || customEmailControl.invalid">Add</button>
      </div>

      @if (hasAnyEmails) {
        <div class="sending-to-label">Sending to:</div>
        @if (notifyEachProvider) {
          <div class="per-provider-notice">Each selected provider will receive a copy of their individual report.</div>
        }
        <mat-chip-set>
          @if (isAllSelected) {
            <mat-chip (removed)="clearAllEmails()">
              All providers ({{ allEmailOptions.length }})
              <button matChipRemove><mat-icon>cancel</mat-icon></button>
            </mat-chip>
          } @else {
            @for (email of dropdownSelectedEmails; track email) {
              <mat-chip (removed)="removeEmail(email)">
                {{ email }}
                <button matChipRemove><mat-icon>cancel</mat-icon></button>
              </mat-chip>
            }
          }
          @for (email of customEmails; track email) {
            <mat-chip (removed)="removeEmail(email)">
              {{ email }}
              <button matChipRemove><mat-icon>cancel</mat-icon></button>
            </mat-chip>
          }
        </mat-chip-set>
      } @else {
        <div class="no-email-notice">No email will be sent.</div>
      }

    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <span class="spacer"></span>
  <button mat-button color="primary" (click)="onRun()"
    [disabled]="form.invalid || (isRunning$ | async) || (isBulkRunning$ | async) || !(isProvidersReady$ | async)">
    {{ isBulkMode ? 'Run ' + selectedProviderCount + ' Reports' : 'Run Report' }}
  </button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
